<template>
  <div>
    <transition name="fade-in" mode="out-in">
      <component :is="component" />
    </transition>
  </div>
</template>

<script>
export default {
  components: {
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue'),
    Cards: () => import('@/components/v2/cards/layouts/AddNewCard.vue'),
    ExistingCards: () =>
      import('@/components/v2/cards/layouts/existingCards/index.vue')
  },
  computed: {
    componentIsExistingCards () {
      return this.$route.params.type === 'existing-cards'
    },
    component () {
      if (this.componentIsExistingCards) {
        return 'existing-cards'
      }
      return 'cards'
    }
  }
}
</script>
